import styled from "styled-components";
import { Box } from "hcss-core";

export const PrintHeader = styled(Box)``;
PrintHeader.defaultProps = {
  mb: 3,
  fontSize: "16pt",
  fontWeight: 700
};
